<script lang="ts">
  import { onMount } from "svelte";

  let {
    email = $bindable(),
    emailInvalid,
    back,
  }: {
    email: string;
    emailInvalid: boolean;
    back: () => void;
  } = $props();

  let input = $state<HTMLInputElement>();
  let value = $state(email);

  // Mirrors server-side EmailAddressFormat and C4C signup; custom regex from https://stackoverflow.com/a/75050279 approximating RFC 5322
  const emailPattern = /^[a-z0-9!#$%&'*+\/=?^_‘{|}~-]+(?:\.[a-z0-9!#$%&'*+\/=?^_‘{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i;

  function validateEmail() {
    input.setCustomValidity(emailPattern.test(value) ? "" : "Please enter a valid email address.");
  }

  function confirm(event) {
    event.preventDefault();
    if (!input.checkValidity()) {
      input.reportValidity();
    } else {
      email = value;
      back();
    }
  }

  onMount(()=>input.focus());
</script>

<form onsubmit={confirm}>
  <h2 class="ui-title">Update Email Address</h2>

  <input
    type="email"
    name="email"
    autocomplete="email"
    placeholder="email@example.co.uk"
    class="ui-input"
    class:border-error={emailInvalid}
    bind:this={input}
    bind:value
    oninput={validateEmail}
    maxlength="80"
    required
  />

  <div class="floating-footer">
    <button class="btn btn-ghost" type="button" onclick={back}>Back</button>
    <button class="btn btn-primary" type="button" onclick={confirm}>Continue</button>
  </div>
</form>
